/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Sexe } from '@/types';

const OPTIONS_SEXE: Record<'key' | 'text' | 'value', string | number>[] = [
  {
    key: 1,
    text: 'Homme',
    value: Sexe.Homme,
  },
  {
    key: 2,
    text: 'Femme',
    value: Sexe.Femme,
  },
];

export default OPTIONS_SEXE;
